import React from 'react';
import { Activity, AlertTriangle, Calendar, Landmark, MessageSquare } from 'lucide-react';
import { formatDateTime } from './kit/time';

// Ticket 174: a "text sent" row gets a message icon and a plain label; a failed
// send (meta.status other than "sent") is flagged in red. Other kinds unchanged.
const KIND_LABELS = {
  text_sent: 'Text message',
  appointment: 'Appointment',
  opportunity_created: 'Opportunity',
  stage_moved: 'Stage move',
};
const KIND_ICONS = {
  text_sent: MessageSquare,
  appointment: Calendar,
  opportunity_created: Landmark,
  stage_moved: Landmark,
};

export function TimelineList({ events }) {
  if (!events || events.length === 0) {
    return (
      <div className="bg-slate-50 border border-dashed border-slate-200 rounded-2xl p-16 text-center text-slate-400" data-testid="timeline-empty">
        <p>No activity yet</p>
      </div>
    );
  }
  return (
    <ul className="space-y-3" data-testid="timeline-list">
      {events.map((e, i) => {
        const text = e.kind === 'text_sent';
        const failed = text && e.meta?.status !== 'sent';
        const Icon = failed ? AlertTriangle : KIND_ICONS[e.kind] || Activity;
        return (
          <li
            key={i}
            data-testid={`timeline-event-${e.kind}`}
            data-status={text ? (failed ? 'failed' : 'sent') : undefined}
            className="flex gap-3 items-start bg-white border border-slate-100 rounded-xl p-4"
          >
            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${failed ? 'bg-red-50 text-red-500' : 'bg-slate-100 text-slate-500'}`}>
              <Icon size={14} />
            </div>
            <div className="flex-1">
              <div className={`text-sm ${failed ? 'text-red-700' : 'text-slate-900'}`}>{e.title}</div>
              <div className="text-[11px] text-slate-400 mt-0.5">{formatDateTime(e.ts)} · {KIND_LABELS[e.kind] || e.kind}</div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
